<!-- seems like ng bug but 'defaultTemplate' is not found by ViewChildren if it's below the main div -->
<ng-template #defaultTemplate [lgChartTemplateContextType]="this" let-context>
    @if (context.data) {
        <b>{{ context.data.column }}</b>
        <br /><br />
        {{ context.data.group }}: {{ this._numberFormat(context.data.value) }}
    }
</ng-template>
<div class="lg-chart-area lg-chart-small-text">
    <div #chart [style.height.px]="height"></div>
    @if (showLegend) {
        <div [style.bottom]="showLegendOffset">
            @for (item of _legend; track item) {
                <div class="entry">
                    <div
                        class="entry__icon lg-chart-legend-icon"
                        [style.background]="item.color"
                    ></div>
                    <div class="entry__name">
                        {{ item.name }}
                    </div>
                </div>
            }
            <div></div>
        </div>
    }
</div>
